import { render, staticRenderFns } from "./PhaseTypeReviewServiceInterface.vue?vue&type=template&id=b6064d86&scoped=true"
import script from "./PhaseTypeReviewServiceInterface.vue?vue&type=script&lang=js"
export * from "./PhaseTypeReviewServiceInterface.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeReviewServiceInterface.vue?vue&type=style&index=0&id=b6064d86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6064d86",
  null
  
)

export default component.exports